import type { AppointmentConfigDoc, ListingDoc } from '@bb/domain/dist/schemas';

import axios from 'axios';

export type GetUnconfiguredUserListingsResponse = {
  listings: Pick<
    ListingDoc,
    | 'id'
    | 'city'
    | 'line1'
    | 'line2'
    | 'postal_code'
    | 'list_price'
    | 'province'
    | 'type'
    | 'thumbnail'
    | 'reps'
  >[];
  showingConfigs: Pick<
    AppointmentConfigDoc,
    | '_id'
    | 'instructions'
    | 'maxDuration'
    | 'access'
    | 'displayedToSeller'
    | 'virtualTourIdentifier'
    | 'lockboxPhoto'
    | 'pendingSentriLockAssignment'
    | 'pendingSentriLockAssignmentRetryTime'
  >[];
};

const getUnconfiguredUserListings = async () => {
  const { data } = await axios.get<GetUnconfiguredUserListingsResponse>(
    '/listing/unconfigured_user_listings',
  );

  return data;
};

export default getUnconfiguredUserListings;
